export const routes = (prefix = `lab`) => [
    {
        path: `/${prefix}/report`,
        name: `${prefix}.report.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.report.index`,
                PageDescription: "Lab: Report",
            },
        },
    },
    {
        path: `/${prefix}/report-print`,
        name: `${prefix}.report-print.index`,
        component: () => import('./prints/LabReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.report.index`,
                PageDescription: "Lab: Report",
            },
        },
    },
];